import { nanoid } from 'nanoid';

import { seoData } from '../../mock/data';

export default ({ data }) => {
  const { twitter } = seoData;
  console.log('data', data);
  console.log('seo', twitter);
  // const imNode = data.allFile.edges.find((n) => n.node.relativePath === twitter.image);
  // console.log('ins', imNode);
  // console.log('check', imNode.node.childImageSharp.fluid.src);
  // console.log('src');
  // const image = imNode ? `${rootUrl.slice(0, -1)}${imNode.node.childImageSharp.fluid.src}` : {};
  // const image = imNode ? imNode.node.publicURL : {};
  console.log('tw', twitter);
  const baseUrl = data.allFile.nodes.find((n) => n.base === twitter.image);
  const imageUrl = `${twitter.url}${baseUrl.publicURL}`;
  console.log('im', imageUrl);
  const twData = twitter
    ? [
      {
        key: nanoid(),
        name: 'twitter:card',
        content: twitter.card,
      },
      {
        key: nanoid(),
        name: 'twitter:site',
        content: twitter.user,
      },
      {
        key: nanoid(),
        property: 'og:url',
        content: twitter.url,
      },
      {
        key: nanoid(),
        property: 'og:title',
        content: twitter.title,
      },
      {
        key: nanoid(),
        property: 'og:description',
        content: twitter.description,
      },
      {
        key: nanoid(),
        property: 'og:image',
        content: imageUrl,
        // content: `${rootUrl}${image.slice(1,image.length)}`,
      },
    ]
    : {};
  return twData;
};
